// apps/web/src/pages/pcp/conferencia-pv/acoes-pv-da-nota.tsx — Fase 12, Plano 27 (PV-04, D-03, D-07).
// Ações do PV no rodapé da conferência da NF. Vocabulário visual (Tailwind cru) da modal da conferência.
// O `numero` do PV já vem com o prefixo (ex.: PV-2026-0003), então o chip mostra só o número.
// Nada é criado aqui: "Criar PV desta nota" só navega ao formulário pré-preenchido, que exige confirmação humana (D-03).
import type { ReactElement } from 'react';
import { modoAcaoPvDaNota } from '../../../lib/vendas/pv-da-nota';
import { usePvDaNota } from './use-pv-da-nota';

// O router escuta `popstate`; despachar o evento é a navegação programática sem reload.
function navegar(destino: string): void {
  window.history.pushState(null, '', destino);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function AcoesPvDaNota({ documentoFiscalId }: { readonly documentoFiscalId: string }): ReactElement | null {
  const estado = usePvDaNota(documentoFiscalId);

  if (estado.tipo === 'oculto') return null;
  if (estado.tipo === 'carregando') {
    return (
      <span role="status" className="text-xs text-slate-500">
        Consultando PV da nota…
      </span>
    );
  }
  if (estado.tipo === 'erro') {
    return <span className="text-xs text-slate-500">Não foi possível consultar o PV desta nota.</span>;
  }

  const { rascunho } = estado;
  const modo = modoAcaoPvDaNota({ temItens: rascunho.temItens, pvsVinculados: rascunho.pvsVinculados });

  if (modo === 'CRIAR') {
    return (
      <button
        type="button"
        onClick={() => navegar(`/vendas/pedidos/novo?nota=${encodeURIComponent(documentoFiscalId)}`)}
        className="px-4 py-2 border border-blue-600 bg-blue-50 text-blue-700 text-sm font-semibold rounded hover:bg-blue-100 focus:ring-2 focus:ring-blue-500 focus:outline-none"
      >
        Criar PV desta nota
      </button>
    );
  }
  if (modo === 'ANEXAR_XML') {
    return <p className="max-w-xs text-xs text-slate-600">Anexe o XML da nota para criar o PV a partir dos itens.</p>;
  }
  if (modo === 'CHIP') {
    return (
      <div className="flex flex-wrap items-center gap-2">
        {rascunho.pvsVinculados.map((pv) => (
          <a
            key={pv.id}
            href={`/vendas/pedidos/detalhe?id=${encodeURIComponent(pv.id)}`}
            className="px-2.5 py-1 bg-blue-50 border border-blue-300 text-blue-700 rounded-full text-xs font-semibold hover:bg-blue-100"
          >
            {pv.numero}
          </a>
        ))}
      </div>
    );
  }
  return null;
}
